<!-- Loading bar -->
<!-- <fuse-loading-bar></fuse-loading-bar> -->

<!-- Navigation -->
@if(isScreenSmall) {
<ng-container>
    <fuse-vertical-navigation
        class="dark bg-gray-900 print:hidden mt-0"
        [mode]="'over'"
        [name]="'mainNavigation'"
        [navigation]="navigation.default"
        [opened]="false"
    >
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            <div class="flex items-center h-20 pt-6 px-8">
                <a [routerLink]="['/dashboard']">
                    <img
                        class="w-full"
                        src="images/logo/logo-text-on-dark.png"
                        alt="Logo image"
                    />
                </a>
            </div>
        </ng-container>
    </fuse-vertical-navigation>
</ng-container>
}

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div
        class="flex flex-0 items-center w-full h-16 px-2 z-49 justify-between shadow dark:shadow-none dark:border-b bg-[#242b36] dark:bg-transparent text-white print:hidden sticky top-0"
    >
        @if(!isScreenSmall) {
        <ng-container>
            <!-- Logo -->
            <div class="flex items-center mx-2 lg:mr-8">
                <div class="hidden lg:flex">
                    <a [routerLink]="['/dashboard']">
                        <img
                            class="dark:hidden w-48"
                            src="images/logo/logo-text-on-dark.png"
                        />
                        <img
                            class="hidden dark:flex w-48"
                            src="images/logo/logo-text-on-dark.png"
                        />
                    </a>
                </div>
                <a [routerLink]="['/dashboard']">
                    <img
                        class="flex lg:hidden min-w-48 w-48"
                        src="images/logo/logo-text-on-dark.png"
                    />
                </a>
                <app-sidebar-desktop
                class="mr-2"
                [navigation]="navigation.horizontal"
                [name]="'mainNavigation'"
            ></app-sidebar-desktop>
            </div>
            <!-- Horizontal navigation -->
            
        </ng-container>
        }
        <!-- Navigation toggle button -->
        @if(isScreenSmall) {
        <ng-container>
            <button
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')"
            >
                <mat-icon
                    class="text-white"
                    [svgIcon]="'heroicons_outline:bars-3'"
                ></mat-icon>
            </button>
        </ng-container>
        }
        <!-- Components -->
        <div class="flex items-center pl-2 space-x-0.5 gap-2 sm:space-x-2">
            <currencies></currencies>
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <search [appearance]="'bar'"></search>
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-row flex-auto overflow-hidden">
        <div class="hidden sm:block">
        <filter-drawer class="block"/>
        </div>
        <div class="flex flex-auto w-full">
            <!-- @if (true) hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
            @if(true) {
            <router-outlet></router-outlet>
            }
        </div>
    </div>

    <!-- Footer -->
     <div class="flex h-14 flex-row justify-evenly items-center sticky bottom-0  bg-white sm:hidden border-t z-10">
        <!-- Filters -->
        <div class="flex justify-center items-center flex-col " (click)="openDialog()">
            <div class="img w-7">
                <img src="icons/filter.svg"  alt="">
            </div>
            <span class="text-s font-medium	">{{ 'filters.title' | transloco }}</span>
        </div>

        <!-- Profile -->
        <div class="flex justify-center items-center flex-col" (click)="openUserDialog()">
            <div class="img w-7">
                <img src="icons/profile.svg"  alt="">
            </div>
            <span  class="text-s font-medium	">{{ 'settings.profile.title' | transloco }}</span>
        </div>
     </div>
</div>

<!-- Quick chat
<quick-chat #quickChat="quickChat"></quick-chat> -->
